import awsAcctService from '@/services/awsacct.service.js'

export default {
  getOnboardingRequests: (context) => {
    context.commit('loadingUserRequests', true)
    awsAcctService.getOnboardingRequestsByUser(context.rootState.currentUser.requestor_id, (res, err) => {
      context.commit('setUserRequests', res)
      context.commit('loadingUserRequests', false)
    })
  },


  // VALIDATION
  
  validateWbsCode: (context, code) => {
    console.log('onWbsValidate 2', code)
    context.commit('resetWbsValidation')
    context.commit('setWbsCodeValidating', true)
    debugger
    awsAcctService.validateWbsCode(code, (res, err) => {
      if (err) {
        context.commit('setWbsValidationResponse', { valid: false, message: err.message })
      } else {
        context.commit('setWbsValidationResponse', { valid: true, type: res.type, message: res.message })
      }

      context.commit('setWbsCodeValidating', false)
    })
  },
  validateIwoCode: (context, code) => {
    console.log('onIwoValidate 2', code)
    context.commit('setIwoCodeValidating', true)
    awsAcctService.validateIwoCode(code, (res, err) => {
      if (err) {
        context.commit('setIwoValidationResponse', { valid: false, message: err.message })
      } else {
        context.commit('setIwoValidationResponse', { valid: true, message: res.message })
      }
      context.commit('setIwoCodeValidating', false)
    })
  },


  getRestrictedRegions: (context, regions) => {
    console.log('----- Actions: Restricted Regions -----')
    awsAcctService.getRestrictedRegions(regions,(res, err) => {
      if(err){
        console.log(err)
      } else {
        context.commit('setRestrictedRegions',res)
      }
    })
  },

  updateAwsRequest:(context, data) =>{
    console.log('------ updateAwsRequest 2 ------')
    console.log(data)
    console.log('--------------------------------')
    context.commit('loadingUpdateAwsReq', true)
    awsAcctService.updateAwsRequest(data, (res,err) =>{
      if(err){

      } else {
        console.log('------updateAWSRequest: Success------')
        console.log(data)
        console.log('--------------------------------------')
        context.commit('loadingUpdateAwsReq', false)
        context.commit('updateViewMyRequestList', data)
        
      }
    })

  }
}
